import { required, optional, obj, array } from "AppReact/schema";

export const featuredVideo = {
  id: required("string"),
  title: required("integer"),
}

export const featuredVideos = {
  can_highlight: required("boolean"),
  highlighted_videos: array(obj(featuredVideo)),
};

export const featuredVideosDefaultValue = {
  can_highlight: false,
  highlighted_videos:[],
};
